exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-user-reservation .table td[data-v-5f3e0522],.p-user-reservation .table th[data-v-5f3e0522]{font-size:.8rem}", ""]);

// exports
